class rocketNewsletter extends HTMLElement {
  constructor() {
    super();

    this.formNewsletter = this.querySelector('#rocket_newsletter_signup');
    this.inputEmail = this.querySelector('input[type="email"]');
    this.buttonBeforeSubmit = this.querySelector('button[type="button"]');
    this.buttonSubmit = this.querySelector('button[type="submit"]');
    this.inputPrivacyTerm = this.querySelector('#checkbox-privacy-terms');
    this.errorMessageEmail = this.querySelector('.error-message-email');
    this.errorMessagePrivacyTerms = this.querySelector('.error-message-privacy-terms');
    this.labelCheckBox = this.querySelector('.label-checkbox-privacy-terms');

    this.addEventInput(this);
    this.addEventBeforeSubmitForm(this);
  }

  addEventInput(self) {
    self.inputEmail.addEventListener('keyup', function() {
      let value = this.value;
      value = value != "" ? false : true;
      self.buttonBeforeSubmit.classList.toggle('signup-form__button-not-text', value)
    })
  }

  addEventBeforeSubmitForm (self) {
    self.buttonBeforeSubmit.addEventListener('click', function() {
      let valueEmail = self.inputEmail.value;
      let statusCheckEmail = self.validateEmail(valueEmail);

      let status = statusCheckEmail ? true : false
      self.errorMessageEmail.classList.toggle('hidden', status);
      self.inputEmail.classList.toggle('error', !statusCheckEmail);
      if(!statusCheckEmail)  {
        return
      }

      if(self.inputPrivacyTerm) {
        let statusCheckboxPrivacyTerm = self.inputPrivacyTerm.checked
        self.errorMessagePrivacyTerms.classList.toggle('hidden', statusCheckboxPrivacyTerm);
        self.labelCheckBox.classList.toggle('error', !statusCheckboxPrivacyTerm);
        if(!statusCheckboxPrivacyTerm) {
          return
        }
      }


      self.buttonSubmit.click();
    })
  }

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }


}
customElements.define('rocket-newsletter', rocketNewsletter)